export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-countdown/index.js